<script>
    import { headerRightBtnCls } from "../../Utils/utilConstants.svelte";
    import { goBack } from "../../Utils/utilFunctions.svelte";
    import BackArrow from "./BackArrow.svelte";

    export let title = "";
    export let subTitle = "";
    export let buttonText = "";
    export let buttonStyle = "";
    export let buttonFunc = () => {};
    export let buttonDisabled = false;
    export let isRevertBtnOrder = false;
    export let buttonIcon = "";
    export let backFunc = () => {
        goBack();
    };
</script>

<div class="flex flex-row gap-x-4 items-center mb-1">
    <BackArrow {backFunc} />
    <div class="flex flex-col">
        <p class="title text-[#6F726C]">{title}</p>
        <p class="subTitle text-[#6F726C]">
            {subTitle}
        </p>
    </div>

    <div
        class={`flex flex-1 gap-4 items-center flex-wrap ${
            isRevertBtnOrder ? "flex-row-reverse" : "flex-row justify-end"
        }`}
    >
        <slot />

        {#if buttonText}
            <button
                class="{headerRightBtnCls} {buttonStyle}"
                on:click={buttonFunc}
                disabled={buttonDisabled}
            >
                {#if buttonIcon}
                    <i class={buttonIcon}></i>
                {/if}
                {buttonText}
            </button>
        {/if}
    </div>
</div>

<style>
    .title {
        font-weight: 700;
        font-size: 22px;
        line-height: 33px;
    }

    .subTitle {
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
    }

    .btn {
        text-transform: capitalize;
    }
</style>
